function triggerSignupForm(formID) {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formID]);
}

// Event listener for the bar button
const barBtnElem = document.getElementById('js-barbtn');
if (null !== barBtnElem) {
  barBtnElem.addEventListener('click', function() {
    const formID = barBtnElem.getAttribute('data-formid');
    triggerSignupForm(formID);
  });
}

// Accordion Initialization
function initAccordion(itemElem, allItems) {
  const itemBtn = itemElem.querySelector('.accordion__item__title button');
  const panel = document.getElementById(itemBtn.getAttribute('aria-controls'));

  itemBtn.addEventListener('click', function () {
    const isExpanded = itemBtn.getAttribute('aria-expanded') === 'true';

    // Close all accordion items
    allItems.forEach((item) => {
      const btn = item.querySelector('.accordion__item__title button');
      const pnl = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', false);
      item.classList.remove('accordion__item--open');
      pnl.hidden = true;
    });

    // Toggle the clicked item
    itemBtn.setAttribute('aria-expanded', !isExpanded);
    itemElem.classList.toggle('accordion__item--open', !isExpanded);
    panel.hidden = isExpanded;

    // Scroll to the opened item
    if (!isExpanded) {
        itemElem.scrollIntoView({
          behavior: 'smooth', // Smooth scrolling
          block: 'start', // Align to the top of the viewport
        });
      }
  });
}

const accordionItemElemArr = Array.from(document.querySelectorAll('.accordion__item'));
accordionItemElemArr.forEach(accordionItemElem => {
  initAccordion(accordionItemElem, accordionItemElemArr);
});


function initReadMore(readMoreElem) {
  const readMoreBtn = readMoreElem.querySelector('button');
  readMoreBtn.addEventListener('click', function() {
    if ('true' == readMoreBtn.getAttribute('aria-expanded')) {
      readMoreBtn.setAttribute('aria-expanded', false);
      readMoreBtn.innerText = readMoreBtn.getAttribute('data-readmore');
      readMoreElem.classList.remove('readmore--open');
      return;
    }
    readMoreBtn.setAttribute('aria-expanded', true);
    readMoreBtn.innerText = readMoreBtn.getAttribute('data-readless');
    readMoreElem.classList.add('readmore--open');
  });
}

const readMoreElemArr = document.querySelectorAll('.readmore');
if (0 < readMoreElemArr.length) {
  readMoreElemArr.forEach(readMoreElem => {
    initReadMore(readMoreElem);
  });
}

function setLocalStorage(key, val) {
  let storageObj = getLocalStorage();
  if (null === storageObj) {
    storageObj = {};
    localStorage.setItem('haydenhilllondon', JSON.stringify(storageObj));
  }
  storageObj[key] = val;
  localStorage.setItem('haydenhilllondon', JSON.stringify(storageObj));
}

function getLocalStorage() {
  let storageObj = null;
  if (localStorage.haydenhilllondon) {
    storageObj = JSON.parse(localStorage.haydenhilllondon);
  }
  return storageObj;
}

function locationCheckNeeded() {
  let storageObj = getLocalStorage();
  if (null === storageObj) {
    return true;
  }
  if ((Date.now() - (60000 * 60 * 3)) > storageObj.locationSwitcherCloseDate) {
    return true;
  }
  return false;
}

function initLocationSwitchDialog(showModal) {
  const dialogElem = document.querySelector('#locationswitcher');
  if (!dialogElem) {
    console.log('location switcher not found.');
    return;
  }
  dialogElem.addEventListener('close', function() {
    console.log('location switcher closed.');
    setLocalStorage('locationSwitcherCloseDate', Date.now());
  });
  dialogElem.querySelector('#js-locationswitcherclose').addEventListener('click', function() {
    dialogElem.close();
  });
  const locationButtonElemArr = document.querySelectorAll('.js-locationbutton');
  if (0 < locationButtonElemArr.length) {
    locationButtonElemArr.forEach(locationButtonElem => {
      locationButtonElem.addEventListener('click', function() {
        dialogElem.showModal();
      });
    });
  }
  if (showModal) {
    dialogElem.showModal();
  }
}

function locationCheck() {
  console.log('Region:', Shopify.customerPrivacy.getRegion());
  if (false == locationCheckNeeded()) {
    console.log('location check not needed.');
    initLocationSwitchDialog(false);
    return;
  }
  const siteCountryCode = document.querySelector('html').getAttribute('lang').toLowerCase().substring(3);
  const currentCountryCode = Shopify.customerPrivacy.getRegion().toLowerCase().substring(0, 2);
  if (siteCountryCode == currentCountryCode) {
    console.log('Location: on correct site, ' + currentCountryCode);
    initLocationSwitchDialog(false);
    return;
  }
  console.log('user location does not match site location, show switcher');
  initLocationSwitchDialog(true);
}

function consentTrackingAPILoaded() {
  if ('undefined' !== typeof Shopify.customerPrivacy && Shopify.customerPrivacy.getRegion()) {
    locationCheck();
    return;
  }
  console.log('no region found.');
  initLocationSwitchDialog(false);
}

Shopify.loadFeatures(
  [
    {
      name: 'consent-tracking-api',
      version: '0.1',
    },
  ],
  error => {
    if (error) {
      console.log('consent-tracking-api not loaded');
    } else {
      consentTrackingAPILoaded();
    }
  }
);

// Mega Menu Customisation for Desktop Only
document.addEventListener("DOMContentLoaded", function () {
  // Check if screen width is greater than 768px
  if (window.matchMedia("(min-width: 66.99em)").matches) {
    const menuLinks = document.querySelectorAll('.site-nav__link[data-menu]');
    menuLinks.forEach(link => {
      const menuId = link.dataset.menu;
      const megaMenu = document.getElementById(`mega-menu-${menuId}`);
      if (megaMenu) {
        let hideTimeout;
        
        // Add event listeners for hover
        link.addEventListener('mouseenter', () => {
          clearTimeout(hideTimeout); // Clear any previous hide timeout
          megaMenu.style.display = 'block';
          link.classList.add('active'); // Add active class to link
        });

        link.addEventListener('mouseleave', () => {
          // Add a delay before hiding the mega menu
          hideTimeout = setTimeout(() => {
            if (!megaMenu.matches(':hover')) { // Ensure the mega menu isn't hovered
              megaMenu.style.display = 'none';
              link.classList.remove('active'); // Remove active class from link
            }
          }, 200); // Delay of 200ms (adjust as needed)
        });

        // Add event listeners for mega menu hover
        megaMenu.addEventListener('mouseenter', () => {
          clearTimeout(hideTimeout); // Clear any previous hide timeout
          megaMenu.style.display = 'block';
          link.classList.add('active'); // Keep link active when mega menu is hovered
        });

        megaMenu.addEventListener('mouseleave', () => {
          // Add a delay before hiding the mega menu when mouse leaves the mega menu
          hideTimeout = setTimeout(() => {
            megaMenu.style.display = 'none';
            link.classList.remove('active'); // Remove active class when leaving mega menu
          }, 200); // Delay of 200ms (adjust as needed)
        });
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const menuBtnElem = document.getElementById('js-menubtn');
  const mobileMenu = document.getElementById('mobile-menu');
  const desktopMenu = document.getElementById('main-menu');
  const breakpoint = window.matchMedia('(min-width: 66.99em)');
  const menuTabs = document.querySelectorAll('.mobile-menu__tab');
  const menuContents = document.querySelectorAll('.mobile-menu__content');
  const submenuLinks = document.querySelectorAll('.mainmenu__item--parent > a');

  // Function to handle menu toggling
  const toggleMenu = () => {
    const isExpanded = menuBtnElem.getAttribute('aria-expanded') === 'true';
    menuBtnElem.setAttribute('aria-expanded', String(!isExpanded));

    const targetMenu = breakpoint.matches ? desktopMenu : mobileMenu;
    if (targetMenu) {
      targetMenu.classList.toggle('open', !isExpanded);
    }
  };

  if (menuBtnElem) {
    menuBtnElem.addEventListener('click', toggleMenu);
  }

  // Tab switching functionality for the mobile menu
  if (menuTabs.length && menuContents.length) {
    menuTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const menuId = tab.getAttribute('data-menu');
        const activeContent = document.getElementById(menuId);

        if (!activeContent) return;

        // Efficiently deactivate active tab and content
        document.querySelector('.mobile-menu__tab.active')?.classList.remove('active');
        document.querySelector('.mobile-menu__content.active')?.classList.remove('active');

        tab.classList.add('active');
        activeContent.classList.add('active');
      });
    });
  }

  // Efficient submenu toggle for touch devices
  if (submenuLinks.length) {
    submenuLinks.forEach((link) => {
      link.addEventListener('touchstart', (e) => {
        e.preventDefault();
        const parent = link.parentElement;

        // Close other submenus efficiently
        document.querySelectorAll('.mainmenu__item--open').forEach((openItem) => {
          if (openItem !== parent) {
            openItem.classList.replace('mainmenu__item--open', 'mainmenu__item--closed');
          }
        });

        parent.classList.toggle('mainmenu__item--open');
        parent.classList.toggle('mainmenu__item--closed');
      }, { passive: false });
    });
  }
});

// --------------CART DRAWER ------------------//
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartIcon = document.querySelector('[data-action="open-cart"]');
  const closeCartDrawer = document.getElementById('close-cart-drawer');

  // Function to open the cart drawer
  function openCartDrawer() {
    fetch('/cart.js') // Fetch the cart's latest content
      .then((response) => {
        if (!response.ok) throw new Error('Failed to fetch shopping bag');
        return response.json();
      })
      .then((cart) => {
        updateCartDrawer(cart); // Update the cart drawer with the latest data
        cartDrawer.classList.add('open');
        cartOverlay.classList.add('active'); // Show overlay
        document.body.classList.add('cart-drawer-open'); // Lock background scroll
      })
      .catch((error) => console.error('Error fetching shopping bag:', error));
  }

  // Function to close the cart drawer
  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('active'); // Hide overlay
    document.body.classList.remove('cart-drawer-open'); // Unlock background scroll
  }

  // Attach the close drawer button event
  if (closeCartDrawer) closeCartDrawer.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Attach event listener to the cart icon to open the cart drawer
  if (cartIcon) {
    cartIcon.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent default link behavior
      openCartDrawer();
    });
  }

  // Update the cart drawer content
  function updateCartDrawer(cart) {
    const cartItemsContainer = document.getElementById('cart-items');
    const cartSubtotal = document.getElementById('cart-subtotal');
    const emptyCartMessage = `
      <div class="cart-empty">
        <p>Your shopping bag is empty</p>
        <a href="/collections" class="btn btn--continue-shopping">Continue Shopping</a>
      </div>
    `;
    // Clear existing items
    cartItemsContainer.innerHTML = '';
    
    // Check if the cart is empty
    if (cart.items.length === 0) {
      cartItemsContainer.innerHTML = emptyCartMessage;
      cartSubtotal.style.display = 'none'; // Hide the subtotal when the cart is empty
      return;
    }
    
    cartSubtotal.style.display = ''; 

    // Add cart items dynamically
    cart.items.forEach((item) => {
      const singlePrice = item.line_price / item.quantity; // Calculate single price
      const cartItem = document.createElement('div');
      cartItem.classList.add('cart-item');
      cartItem.innerHTML = `
        <div class="cart-item__image">
          <img src="${item.image}" alt="${item.title}">
        </div>
        <div class="cart-item__details">
          <p class="cart-item__title">${item.title}</p>
          <p class="cart-item__price">${formatMoney(singlePrice)}</p>
          <div class="cart-item__quantity">
            <div class="quantity-selector">
              <button 
                type="button" 
                class="quantity-selector__button quantity-selector__button--decrease" 
                data-key="${item.key}" 
                aria-label="Decrease quantity"
              >
                −
              </button>
              <input 
                type="number" 
                id="quantity-${item.key}" 
                name="quantity" 
                min="1" 
                value="${item.quantity}" 
                data-key="${item.key}" 
                class="quantity-selector__input"
              />
              <button 
                type="button" 
                class="quantity-selector__button quantity-selector__button--increase" 
                data-key="${item.key}" 
                aria-label="Increase quantity"
              >
                +
              </button>
              
            </div>
            <button 
              class="cart-item__remove" 
              data-key="${item.key}" 
              aria-label="Remove item"
            >
              Remove
            </button>
          </div>
          
        </div>
      `;
      cartItemsContainer.appendChild(cartItem);
    });

    // Update subtotal
    cartSubtotal.querySelector('span').textContent = formatMoney(cart.total_price);

    // Update cart icon count
    if (cartIcon) {
      cartIcon.setAttribute('data-cartcount', cart.item_count);
    }

    // Attach events to new elements
    attachQuantityUpdateEvents();
    attachRemoveItemEvents();
  }

  // Format money
  function formatMoney(amount, format = "£{{amount}}") {
    const value = (amount / 100).toFixed(2);
    return format.replace('{{amount}}', value);
  }

  // Attach events for quantity updates
  function attachQuantityUpdateEvents() {
    document.querySelectorAll('.quantity-selector__button--increase, .quantity-selector__button--decrease').forEach((button) => {
      button.addEventListener('click', (event) => {
        const key = button.dataset.key;
        const input = document.querySelector(`.quantity-selector__input[data-key="${key}"]`);
        const currentQuantity = parseInt(input.value, 10) || 1;
        const newQuantity = button.classList.contains('quantity-selector__button--increase')
          ? currentQuantity + 1
          : Math.max(1, currentQuantity - 1);

        input.value = newQuantity;
        updateCartQuantity(key, newQuantity);
      });
    });
  }

  // Update cart quantity via API
  function updateCartQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then(() => fetch('/cart.js')) // Fetch the updated cart
      .then((response) => {
        if (!response.ok) throw new Error('Failed to fetch updated bag');
        return response.json();
      })
      .then((updatedCart) => {
        updateCartDrawer(updatedCart);
      })
      .catch((error) => console.error('Error updating bag quantity:', error));
  }

  // Attach remove item events
  function attachRemoveItemEvents() {
    document.querySelectorAll('.cart-item__remove').forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.dataset.key;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        })
          .then(() => fetch('/cart.js')) // Fetch the updated cart
          .then((response) => {
            if (!response.ok) throw new Error('Failed to fetch updated cart');
            return response.json();
          })
          .then((updatedCart) => {
            updateCartDrawer(updatedCart);
          })
          .catch((error) => console.error('Error removing item from cart:', error));
      });
    });
  }

  // Attach event listeners to forms for adding items to the cart
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
  
      const formData = new FormData(form);
  
      // Add item to cart via Shopify API
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Failed to add item to cart');
          }
          return response.json();
        })
        .then(() => fetch('/cart.js')) // Fetch updated cart
        .then((response) => {
          if (!response.ok) {
            throw new Error('Failed to fetch cart');
          }
          return response.json();
        })
        .then((updatedCart) => {
          updateCartDrawer(updatedCart); // Update the cart drawer
          openCartDrawer(); // Open the cart drawer
        })
        .catch((error) => console.error('Error adding item to cart:', error));
    });
  });

  // Attach event listener to thumbnail CTA buttons
  document.querySelectorAll('.add-to-cart').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const variantId = button.getAttribute('data-variant-id');
      const quantity = button.getAttribute('data-quantity') || 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: parseInt(quantity, 10) }),
      })
        .then(() => fetch('/cart.js')) // Fetch the updated cart
        .then((response) => {
          if (!response.ok) throw new Error('Failed to fetch updated cart');
          return response.json();
        })
        .then((updatedCart) => {
          updateCartDrawer(updatedCart);
          openCartDrawer();
        })
        .catch((error) => console.error('Error adding item to cart:', error));
    });
  });
});

// Sticky Header
document.addEventListener("DOMContentLoaded", function() {
  let lastScrollTop = 0; // Track the last scroll position
  const header = document.querySelector('#shopify-section-static-header'); // Target the header element
  const stickyClass = 'sticky-header'; // The class we'll add to the header when sticky
  const contentWrapper = document.querySelector('main'); // The content below the header

  // Add event listener for scroll event
  window.addEventListener('scroll', function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop; // Get current scroll position
    const headerHeight = header.offsetHeight; // Get the height of the header dynamically

    // Only apply sticky header functionality when the page has been scrolled more than 200px
    if (scrollTop > 200) {
      // If scrolling up and past 200px, make the header sticky
      if (scrollTop < lastScrollTop) {
        header.classList.add(stickyClass);
        // Adjust the content padding dynamically based on the header height
        contentWrapper.style.paddingTop = `${headerHeight}px`;
      } else {
        // If scrolling down, remove sticky class and reset padding
        header.classList.remove(stickyClass);
        contentWrapper.style.paddingTop = '0'; // Reset the padding when the header is not sticky
      }
    } else {
      // If less than 200px, remove sticky class and reset padding
      header.classList.remove(stickyClass);
      contentWrapper.style.paddingTop = '0'; // Reset the padding
    }

    // Update last scroll position
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Prevent negative scroll value
  });
});
